import { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import styled from 'styled-components';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';

const HoldingSettingCountInput = forwardRef((props, ref) => {
  const { text, onBlur } = props;

  const [dateVal, setDateVal] = useState(0);

  const InputRef = useRef();
  // 최근 commit 성공한 값 (혹은 외부 setValue로 동기화된 값) — 실패 시 롤백 기준 //
  const lastCommittedRef = useRef(0);
  // input focus 시점 값 (blur 시 변경 판정용) //
  const focusSnapshotRef = useRef(0);

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setDateVal(val);
      lastCommittedRef.current = val;
    },
    getValue: () => {
      return dateVal;
    }
  }))

  // 공통 commit — 직전 값과 같으면 skip, 다르면 onBlur(val, rollback) 호출 //
  function commit(nextVal) {
    if (nextVal === lastCommittedRef.current) return;
    const prev = lastCommittedRef.current;
    lastCommittedRef.current = nextVal;
    if (onBlur) onBlur(nextVal, () => {
      setDateVal(prev);
      lastCommittedRef.current = prev;
    });
  }

  // 입력값 변경시 //
  function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
    setDateVal(result === '' ? 0 : parseInt(result));
  }

  // 입력 포커스시 — blur 시 변경 판정용 스냅샷 //
  function onFocusInput() {
    focusSnapshotRef.current = dateVal;
  }

  // 입력 포커스 해제시 //
  function onBlurInput() {
    if (dateVal === focusSnapshotRef.current) return;
    commit(dateVal);
  }

  // 증가 버튼 클릭시 //
  function onClickUp() {
    const next = dateVal + 1;
    setDateVal(next);
    commit(next);
  }

  // 감소 버튼 클릭시 //
  function onClickDown() {
    if (dateVal > 0) {
      const next = dateVal - 1;
      setDateVal(next);
      commit(next);
    }
  }

  return (
    <TopLevelWrapper>
      <Input
        ref={InputRef}
        placeholder={0}
        value={dateVal}
        onChange={onChangeInput}
        onFocus={onFocusInput}
        onBlur={onBlurInput} />
      <ButtonWrapper>
        <Button onClick={onClickUp}><StyledArrow isUp={true} /></Button>
        <Button onClick={onClickDown}><StyledArrow isUp={false} /></Button>
      </ButtonWrapper>
      <Text
        fontFamily='NotoSansKR-Regular'
        fontSize={12}>
        {text}
      </Text>
    </TopLevelWrapper>
  )
})

export default HoldingSettingCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 8px;

  transition: all 0.3s ease-in-out;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 69px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  padding: 0 0 0 8px;
  margin: 0 5px 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.line};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
  margin-right: 8px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isUp ? 'rotate(90deg)' : 'rotate(-90deg)'};

  & path {
    fill: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;
